import axios from 'axios'

let axiosInstance = null

export default {
  methods: {
    playMusic (track, playlistId = null, filterList = null) {
      this.$store.dispatch('jukebox/getInstance')
        .then((jukebox) => {
          if (jukebox.state?.track_id === track.id && jukebox.state.percentCompleted < 100) {
            if (jukebox.isPlaying()) {
              jukebox.pause()
            } else {
              jukebox.continue()
            }

            return
          }

          let categoryId = ''

          if (Array.isArray(track.categories) && track.categories.length > 0) {
            categoryId = track.categories[0].id
          }

          jukebox.play({
            track_id: track.id,
            playlist_id: playlistId,
            category_id: categoryId,
            category_filter: filterList,
            shuffle: this.$store.state.jukebox.shuffle,
            repeat: this.$store.state.jukebox.repeat,
            position: 0
          })
        })
    },
    getPlaylists ({ isFeatured, page = 1 } = {}) {
      this.initMusicAxios()

      let featured = isFeatured

      if (isFeatured !== undefined) {
        featured = ~~featured
      }

      return axiosInstance
        .get('/v1/playlists/', {
          params: {
            page,
            featured
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    getPlaylist (id) {
      this.initMusicAxios()

      return axiosInstance
        .get(`/v1/playlists/${id}/`)
        .then(({ data }) => {
          return data
        })
    },
    getUserPlaylists ({ search = '', page = 1, perPage = 5 } = {}) {
      this.initMusicAxios()

      return axiosInstance
        .get(`/v1/users/${this.$store.getters['user/currentId']}/playlists/`, {
          params: {
            page,
            per_page: perPage,
            q: search
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    createPlaylist (form) {
      this.initMusicAxios()

      return axiosInstance
        .post(`/v1/users/${this.$store.getters['user/currentId']}/playlists/`, form)
        .then(({ data }) => {
          return data
        })
    },
    updatePlaylist (id, form) {
      this.initMusicAxios()

      return axiosInstance.put(`/v1/users/${this.$store.getters['user/currentId']}/playlists/${id}/`, form)
    },
    deletePlaylist (id) {
      this.initMusicAxios()

      return axiosInstance.delete(`/v1/playlists/${id}/`)
    },
    addPlaylistTrack (track) {
      this.initMusicAxios()

      this.$store.commit('jukebox/SHOW_MODAL_PLAYLIST_SELECT', (playlist) => {
        axiosInstance
          .post(`/v1/playlists/${playlist.id}/tracks/`, { id: track.id })
          .then(() => {
            this.$toast.success(
              this.$t('dashboard.music.playlist.add_success', {
                track: track.name,
                playlist: playlist.name
              }).toString()
            )
          })
          .catch(() => {
            this.$toast.error(this.$t('dashboard.error.500').toString())
          })
      })
    },
    updatePlaylistTrackOrder (playlistId, trackId, newPosition) {
      this.initMusicAxios()

      return axiosInstance
        .patch(`/v1/playlists/${playlistId}/tracks/${trackId}/`, {
          order: newPosition
        })
    },
    removePlaylistTrack (playlistId, track) {
      this.initMusicAxios()

      const promise = axiosInstance
        .delete(`/v1/playlists/${playlistId}/tracks/${track.id}/`)

      promise.catch(() => {
        this.$toast.error(this.$t('dashboard.error.500').toString())
      })

      return promise
    },
    getConsumedTime () {
      this.initMusicAxios()

      return axiosInstance
        .get(`/v1/users/${this.$store.getters['user/currentId']}/time/`)
        .then(({ data }) => {
          return data
        })
    },
    getMusicList ({ category, playlistId, page = 1, query } = {}) {
      this.initMusicAxios()

      if (typeof query !== 'undefined') {
        const forceArray = ['genres', 'moods']

        for (const key of Object.keys(query)) {
          if (forceArray.includes(key) && !Array.isArray(query[key])) {
            query[key] = [query[key]]
          }
        }
      }

      let url = ''

      if (playlistId) {
        url = `/v1/playlists/${playlistId}/tracks/`
      } else if (category) {
        url = `/v1/categories/${category}/tracks/`
      } else {
        throw new Error('INVALID_ARGUMENTS')
      }

      return axiosInstance
        .get(url, {
          params: {
            page,
            ...query
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    getMusicCategories () {
      this.initMusicAxios()

      return axiosInstance
        .get('/v1/categories/')
        .then(({ data }) => {
          const tempCategories = data.filter(category => !category.image_url)
          const categories = []
          let currentLetter = 'a'
          let current = []
          let i = 0

          tempCategories.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)

          do {
            const category = tempCategories[i]
            const categoryLetter = category.name.substr(0, 1).toLowerCase()

            if (categoryLetter !== currentLetter) {
              if (current.length) {
                categories.push({
                  id: null,
                  name: currentLetter.toUpperCase(),
                  categories: current
                })
              }

              current = []
              currentLetter = categoryLetter
            }

            current.push(category)

            i++
          } while (i < tempCategories.length)

          const featuredCategories = data.filter(category => category.image_url)
          featuredCategories.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)

          return {
            featuredCategories,
            categories
          }
        })
    },
    initMusicAxios () {
      if (axiosInstance) {
        return
      }

      axiosInstance = axios.create({
        headers: {
          Authorization: this.$auth.strategy.token.get(),
          common: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      })

      axiosInstance.defaults.baseURL = process.env.JUKEBOX_MUSIC_URL
    }
  }
}
